import React from 'react';
import {
  Grid,
  TextField,
  Alert,
  Box,
  Typography,
} from '@mui/material';

const CampaignFormStep1 = ({ formData, handleInputChange, errors = {} }) => {
  return (
    <Box>
      <Alert severity="info" sx={{ mb: 3 }}>
        Fill in the campaign details. Campaign dates will be set when you select and assign slots.
      </Alert>

      <Grid container spacing={3}>
        {/* 1. Client Name */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Client Name"
            name="clientName"
            value={formData.clientName || ''}
            onChange={handleInputChange}
            required
            error={Boolean(errors?.clientName)}
            helperText={errors?.clientName || 'Enter the name of your client'}
          />
        </Grid>

        {/* 2. Campaign Name */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Campaign Name"
            name="name"
            value={formData.name || ''}
            onChange={handleInputChange}
            required
            error={Boolean(errors?.name)}
            helperText={errors?.name || 'Enter your campaign name'}
          />
        </Grid>

        {/* 3. Offer Number */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Offer Number"
            name="offerNumber"
            value={formData.offerNumber || ''}
            onChange={handleInputChange}
            required
            placeholder="e.g., TSMS-03-01"
            error={Boolean(errors?.offerNumber)}
            helperText={errors?.offerNumber || 'Enter the offer number for this campaign'}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CampaignFormStep1;
